import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="relative flex items-center justify-center w-10 h-10 rounded-lg bg-muted hover:bg-muted/80 transition-all duration-300 group"
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      {/* Sun icon for light mode */}
      <Sun 
        className={`absolute w-5 h-5 text-amber-500 transition-all duration-300 ${
          theme === 'light' ?'opacity-100 rotate-0 scale-100' :'opacity-0 rotate-90 scale-0'
        }`}
      />
      
      {/* Moon icon for dark mode */}
      <Moon 
        className={`absolute w-5 h-5 text-blue-400 transition-all duration-300 ${
          theme === 'dark' ?'opacity-100 rotate-0 scale-100' :'opacity-0 -rotate-90 scale-0'
        }`}
      />
      
      {/* Hover effect ring */}
      <span className="absolute inset-0 rounded-lg ring-2 ring-transparent group-hover:ring-primary/20 transition-all duration-300" />
    </button>
  );
};

export default ThemeToggle;